import { HealthService } from '~/support/services';

import { CLEAR_COMPOSITES_PAGE, SET_COMPOSITE, SET_COMPOSITES_PAGE } from './mutation-types';

export default {
  clearHealthDashboardData({ commit }) {
    commit(CLEAR_COMPOSITES_PAGE);
  },

  async fetchCompositeDatasets({ commit }, { id, pageToken }) {
    const service = new HealthService(useRuntimeConfig().public.healthBaseUrl);
    const data = await service.fetchCompositeDatasets({
      id,
      pageToken,
    });

    commit(SET_COMPOSITE, {
      id,
      page: data,
    });

    return data;
  },

  async fetchComposites({ commit }, { filters, pageToken, query }) {
    const service = new HealthService(useRuntimeConfig().public.healthBaseUrl);
    const data = await service.fetchComposites({
      filters,
      pageToken,
      query,
    });

    commit(SET_COMPOSITES_PAGE, data);

    return data;
  },

  async fetchDataset(_, id) {
    const service = new HealthService(useRuntimeConfig().public.healthBaseUrl);
    const data = await service.fetchDataset(id);

    return data;
  },

  async fetchDatasetDelivery(_, { datasetId, deliveryId }) {
    const service = new HealthService(useRuntimeConfig().public.healthBaseUrl);
    const data = await service.fetchDatasetDelivery(datasetId, deliveryId);

    return data;
  },

  async fetchDatasetDeliveryDispatchLogs(_, { datasetId, exportId }) {
    const service = new HealthService(useRuntimeConfig().public.healthBaseUrl);
    const data = await service.fetchDatasetDeliveryDispatchLogs({ datasetId, exportId });

    return data;
  },

  async fetchDatasetDeliveryPdkLogs(_, { datasetId, deliveryId }) {
    const service = new HealthService(useRuntimeConfig().public.healthBaseUrl);
    const data = await service.fetchDatasetDeliveryPdkLogs({ datasetId, deliveryId });

    return data;
  },

  async fetchDatasetDeliveryV2(_, deliveryId) {
    const service = new HealthService(useRuntimeConfig().public.healthBaseUrl);
    const data = await service.fetchDatasetDeliveryV2(deliveryId);

    return data;
  },

  async fetchDatasetLatestDelivery(_, id) {
    const service = new HealthService(useRuntimeConfig().public.healthBaseUrl);
    const data = await service.fetchDatasetLatestDelivery(id);

    return data;
  },

  async fetchDatasetV2(_, id) {
    const service = new HealthService(useRuntimeConfig().public.healthBaseUrl);
    const data = await service.fetchDatasetV2(id);

    return data;
  },

  async fetchDatasets() {
    const service = new HealthService(useRuntimeConfig().public.healthBaseUrl);
    const data = await service.fetchDatasets();

    return data;
  },

  async fetchDatasetsCount() {
    const service = new HealthService(useRuntimeConfig().public.healthBaseUrl);
    const data = await service.fetchDatasetsCount();

    return data;
  },

  async fetchDatasetsV2(_, { filters, pageToken, query, sortSettings } = {}) {
    const service = new HealthService(useRuntimeConfig().public.healthBaseUrl);
    const data = await service.fetchDatasetsV2({ filters, pageToken, query, sortSettings });

    return data;
  },

  async fetchDeliveryTaskHistory(_, { deliveryId }) {
    const service = new HealthService(useRuntimeConfig().public.healthBaseUrl);
    const data = await service.fetchDeliveryTaskHistory(deliveryId);

    return data;
  },

  async fetchStatistics() {
    const service = new HealthService(useRuntimeConfig().public.healthBaseUrl);
    const data = await service.fetchStatistics();

    return data;
  },

  async rerunDatasetDelivery(_, { datasetId, deliveryId }) {
    const service = new HealthService(useRuntimeConfig().public.healthBaseUrl);
    const data = await service.rerunDatasetDelivery(datasetId, deliveryId);

    return data;
  },
};
